import { faEdit, faEllipsisH, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

class LocationDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false
    };
  }
  toggleDropdown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  render() {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown.bind(this)}>
          <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={this.state.dropdownOpen}>
            <FontAwesomeIcon icon={faEllipsisH} color='var(--card-subtitle-color)' />
          </DropdownToggle>
          <DropdownMenu>
            {this.props.onEdit && (
              <DropdownItem
                onClick={() => this.props.onEdit(this.props.item, this.props.itemIndex)}
                className='primary-font-color'
              >
                <FontAwesomeIcon icon={faEdit} color='var(--primary-font-color)' /> Edit
              </DropdownItem>
            )}
            <DropdownItem
              onClick={() => this.props.onDelete(this.props.item, this.props.itemIndex)}
              className='primary-font-color'
            >
              <FontAwesomeIcon icon={faTrash} color='var(--primary-font-color)' /> &nbsp;Delete
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

export default LocationDropdown;
